// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  Input,
} from "reactstrap";
import { useState, useEffect, useMemo } from "react";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";
import UserModal from "./user-modal/UserModal";
import BanModal from "./user-modal/BanModal";
import CreateUserModal from "./user-modal/CreateUserModal";
import {
  DataTable,
  FilterBar,
  StatusBadge,
  TablePagination,
} from "components/shared";
import UserWithdrawModal from "./UserWithdrawModal";
//data
import {
  USERS_API,
  USER_CHANGE_PASSWORD_API,
  USER_UPDATE_API,
  WITHDRAW_API,
  TOPUP_API,
  ADMIN_TOPUP,
  USER_DETAIL,
} from "../../services/CONSTANTS";
import {
  getApiDataService,
  postApiDataService,
  putApiDataService,
} from "../../services/apiServices";
import UserDepositModal from "./UserDepositModal";
import { debounce, set } from "lodash";
import AdminTopupModal from "./AdminTopupModal";

const buildUserColumns = (status) => {
  const columns = [{ key: "index", label: "#" }];
  if (status !== "CS") {
    columns.push({ key: "userCode", label: "UserCode" });
  }
  columns.push(
    { key: "name", label: "Name" },
    { key: "email", label: "Email(or)Phone" }
  );
  if (status === "USER") {
    columns.push(
      { key: "mmk", label: "MMK" },
      { key: "bath", label: "Bath" },
      { key: "point", label: "Point" }
    );
  }
  if (status === "RESELLER") {
    columns.push(
      { key: "diamond", label: "Diamond" },
      { key: "akhCoin", label: "AKH-Coin" }
    );
  }
  columns.push({ key: "status", label: "Status" }, { key: "actions", label: "" });
  return columns;
};

const UserList = () => {
  const history = useHistory();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [modal, setModal] = useState(false);
  const [Cmodal, setCModal] = useState(false);
  const [item, setItem] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [meta, setMeta] = useState({});
  const [status, setStatus] = useState("USER");
  const [password, setPassword] = useState(null);
  const [isShowPasswordModel, setIsShowPasswordModel] = useState(false);
  const [one, setOne] = useState(false);
  const [statusActive, setStatusActive] = useState(false);
  const [active, setActive] = useState(false);
  const [isBtnLoading, setisBtnLoading] = useState(false);
  const [search, setSearch] = useState(null);
  const [isShowWithdrawModal, setIsShowWithdrawModal] = useState(false);
  const [isShowDepositModal, setIsShowDepositModal] = useState(false);
  const [isShowAdminTopupModal, setIsShowAdminTopupModal] = useState(false);
  const [searchUser, setSearchUser] = useState("");
  const [balance, setBalance] = useState(null);

  let api = USERS_API + `?page=${page}&perPage=${perPage}`;
  api += status ? `&role=${status}` : "";
  api += search ? `&search=${search}` : ``;

  useEffect(() => {
    fetchUsers();
  }, [api, page, status, one, statusActive, active]);

  const fetchUsers = () => {
    setIsLoading(true);
    getApiDataService(api)
      .then((res) => {
        console.log("res.data=", res.data);
        setUsers(res.data);
        setIsLoading(false);
        setMeta(res.meta);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setUsers([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  let fetchUserDetail = () => {
    let user_id = sessionStorage.getItem("user_id");
    getApiDataService(USER_DETAIL(user_id))
      .then((res) => {
        console.log("fetchUserDetail", res);
        setBalance(res.data?.wallets);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (status == "RESELLER") {
      const password = prompt("Please enter your password:", "");
      if (password == "123123") {
        fetchUserDetail();
      } else {
        setStatus("USER");
      }
    }
  }, [status]);

  const passChangeHandler = (data) => {
    setisBtnLoading(true);
    postApiDataService(USER_CHANGE_PASSWORD_API, data).then((res) => {
      if (res.status === "success" || res.data.status === "success") {
        setisBtnLoading(false);
        setModal1(false);
      }
    });
  };

  const handleStatus = (e) => {
    console.log("status", e.target.value);
    setStatus(e.target.value);
  };

  const confirmCreate = (data) => {
    postApiDataService(USERS_API, data).then((res) => {
      if (res.status === "success" || res.data.status === "success") {
        setCModal(false);
        setOne(!one);
      }
    });
  };

  useEffect(() => {
    if (searchUser.length > 0) {
      const searchDebounce = debounce(() => {
        setSearch(searchUser);
      }, 2000);
      searchDebounce(searchUser);
      return () => {
        searchDebounce.cancel();
      };
    }
  }, [searchUser]);

  const handleToggleStatus = (user) => {
    setIsLoading(true);
    console.log("user id ", user?.id);
    let data = {
      status: user?.status === "active" ? "disable" : "active",
    };
    putApiDataService(USER_UPDATE_API(user?.id), data).then((res) => {
      if (res.status === "success" || res.data.status === "success") {
        setStatusActive(!statusActive);
        setIsLoading(false);
      }
    });
  };

  const handleWithdrawSubmit = (data) => {
    console.log("handleWithdrawSubmit", data);
    setIsLoading(true);
    postApiDataService(WITHDRAW_API, data)
      .then((res) => {
        if (res.status === "success" || res.data.status === "success") {
          setIsShowWithdrawModal(false);
          setIsLoading(false);
          fetchUsers();
          fetchUserDetail();
        }
      })
      .catch((err) => {
        console.log("Error in handleWithdrawSubmit!", err);
        setIsLoading(false);
      });
  };

  const handleDepositSubmit = (data) => {
    console.log("handleDepositSubmit", data);
    setIsLoading(true);
    postApiDataService(TOPUP_API, data)
      .then((res) => {
        if (res.status === "success" || res.data.status === "success") {
          setIsShowDepositModal(false);
          setIsLoading(false);
          fetchUsers();
          fetchUserDetail();
        }
      })
      .catch((err) => {
        console.log("Error in handleWithdrawSubmit!", err);
        setIsLoading(false);
      });
  };

  const handleAdminTopupSubmit = (data) => {
    postApiDataService(ADMIN_TOPUP, data)
      .then((res) => {
        if (res.status === "success" || res.data.status === "success") {
          setIsShowAdminTopupModal(false);
          setIsLoading(false);
          fetchUserDetail();
        }
      })
      .catch((err) => {
        console.log("Error in handleWithdrawSubmit!", err);
        setIsLoading(false);
      });
  };

  const handleBtnWithdraw = (user) => {
    setItem(user);
    setIsShowWithdrawModal(true);
  };

  const handleBtnDeposit = (user) => {
    setItem(user);
    setIsShowDepositModal(true);
  };

  const userColumns = useMemo(() => buildUserColumns(status), [status]);

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7 akh-page-content" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar title={`${status} Lists`}>
                  {balance && (
                    <div>
                      <span className="">
                        SmileCoin -{" "}
                        {
                          balance.find(
                            (wallet) => wallet.currency == "SmileCoin"
                          )?.unit_amount
                        }
                      </span>

                      <br></br>
                      <span className="">
                        AKH-Coin -{" "}
                        {
                          balance.find(
                            (wallet) => wallet.currency == "AKH-Coin"
                          )?.unit_amount
                        }
                      </span>
                      <button
                        className="btn btn-success btn-sm"
                        aria-label="Admin topup"
                        onClick={(e) => {
                          e.preventDefault();
                          setIsShowAdminTopupModal(true);
                        }}
                      >
                        +
                      </button>
                    </div>
                  )}

                  <Input
                    type="text"
                    className="akh-filter-width"
                    placeholder="Search"
                    aria-label="Search users"
                    onChange={(e) => setSearchUser(e.target.value)}
                  />
                  <Input
                    className="akh-filter-select"
                    type="select"
                    value={status}
                    onChange={handleStatus}
                    aria-label="Filter by role"
                  >
                    <option value="USER">Users(Customer) </option>
                    <option value="ADMIN">Admin </option>
                    <option value="CS">CS </option>
                    <option value="RESELLER">Reseller </option>
                  </Input>
                  {status === "CS" || status == "RESELLER" ? (
                    <button
                      className="btn btn-primary"
                      onClick={() => setCModal(true)}
                    >
                      Create
                    </button>
                  ) : (
                    ""
                  )}
                </FilterBar>
              </CardHeader>
              <DataTable
                className="table-striped"
                columns={userColumns}
                data={users}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(user, index) => (
                  <tr key={user?.id ?? index}>
                    <th>{(meta.page - 1) * meta.perPage + index + 1}</th>
                    {status !== "CS" ? (
                      <td className="font-mono">{user?.userCode}</td>
                    ) : null}
                    <th scope="row">
                      <span className="mb-0 text-sm">{user?.name}</span>
                    </th>
                    <td>{user?.email ? user?.email : user?.phone}</td>
                    {status == "USER" && (
                      <>
                        <td className="font-mono">
                          {
                            user?.wallets.find(
                              (wallet) => wallet.currency == "MMK"
                            )?.unit_amount
                          }
                        </td>
                        <td className="font-mono">
                          {
                            user?.wallets.find(
                              (wallet) => wallet.currency == "THB"
                            )?.unit_amount
                          }
                        </td>
                        <td className="font-mono">
                          {
                            user?.wallets.find(
                              (wallet) => wallet.currency == "POINT"
                            )?.unit_amount
                          }
                        </td>
                      </>
                    )}
                    {status == "RESELLER" && (
                      <>
                        <td className="font-mono">
                          {
                            user?.wallets.find(
                              (wallet) => wallet.currency == "SmileCoin"
                            )?.unit_amount
                          }
                        </td>
                        <td className="font-mono">
                          {
                            user?.wallets.find(
                              (wallet) => wallet.currency == "AKH-Coin"
                            )?.unit_amount
                          }
                        </td>
                      </>
                    )}
                    {status !== "CS" ? (
                      <td>
                        <StatusBadge
                          status={user?.status}
                          label={
                            user?.status === "disable" &&
                            user.banned_till !== null
                              ? "Banned Till " +
                                new Date(
                                  user?.banned_till
                                ).toLocaleDateString("fr-CA")
                              : user?.status === "disable" &&
                                user.banned_till === null
                              ? "Disable"
                              : "Active"
                          }
                        />
                      </td>
                    ) : (
                      <td>
                        <label className="custom-toggle">
                          <input
                            type="checkbox"
                            checked={
                              user?.status === "active" ? true : false
                            }
                            onChange={(e) => {
                              e.preventDefault();
                              handleToggleStatus(user);
                            }}
                          />
                          <span className="custom-toggle-slider rounded-circle" />
                        </label>
                      </td>
                    )}
                    {user?.role === "ADMIN" ? (
                      <td />
                    ) : (
                      <td className="text-right">
                        <div className="row">
                          <div className="col">
                            <button
                              className="btn btn-info btn-sm"
                              onClick={(e) => {
                                e.preventDefault();
                                setItem(user);
                                setModal1(true);
                              }}
                            >
                              Change Password
                            </button>
                            {status !== "CS" ? (
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => {
                                  setItem(user);
                                  setModal(true);
                                }}
                              >
                                Ban
                              </button>
                            ) : null}
                            {(status == "USER" || status == "RESELLER") && (
                              <>
                                <button
                                  className="btn btn-success btn-sm"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleBtnDeposit(user);
                                  }}
                                >
                                  + Deposit
                                </button>

                                <button
                                  className="btn btn-warning btn-sm"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleBtnWithdraw(user);
                                  }}
                                >
                                  - Withdraw
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </td>
                    )}
                  </tr>
                )}
              />

              <TablePagination meta={meta} page={page} setPage={setPage} />
            </Card>
          </div>
        </Row>
      </Container>
      <UserModal
        item={item}
        isBtnLoading={isBtnLoading}
        passChangeHandler={passChangeHandler}
        onClose={() => setModal1(false)}
        modal={modal1}
      />
      <BanModal
        item={item}
        active={active}
        setActive={setActive}
        isBtnLoading={isBtnLoading}
        onClose={() => setModal(false)}
        modal={modal}
      ></BanModal>
      <CreateUserModal
        item={item}
        status={status}
        onSubmit={confirmCreate}
        onClose={() => setCModal(false)}
        modal={Cmodal}
      ></CreateUserModal>

      {isShowWithdrawModal && (
        <UserWithdrawModal
          id={item.id}
          type={status}
          isLoading={isLoading}
          onSubmit={handleWithdrawSubmit}
          onClose={() => {
            setIsShowWithdrawModal(false);
          }}
        />
      )}

      {isShowDepositModal && (
        <UserDepositModal
          id={item.id}
          type={status}
          isLoading={isLoading}
          onSubmit={handleDepositSubmit}
          onClose={() => {
            setIsShowDepositModal(false);
          }}
        />
      )}
      {isShowAdminTopupModal && (
        <AdminTopupModal
          onSubmit={handleAdminTopupSubmit}
          isLoading={isLoading}
          onClose={() => {
            setIsShowAdminTopupModal(false);
          }}
        />
      )}
    </>
  );
};

export default UserList;
